import styled from 'styled-components'

export const AboutContainer = styled.div`
  color: #000;
  background: #D3D3D3;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
  height: 1000px;

  @media screen and (max-width: 768px) {
    padding: 110px 0;
    height: 1600px;
    overflow-y: hidden;
  }
`

export const AboutWrapper = styled.div`
  display: grid;
  z-index: 3;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
  align-items: center;
  position: absolute;
`

export const AboutSectionBg = styled.img`
  background-repeat: no-repeat;
  width: 100%;
  overflow: hidden;
  /* filter: brightness(30%); */

  @media screen and (max-width: 768px) {
    overflow-y: hidden;
  }
`

export const AboutRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media screen and (max-width: 850px) {
    flex-direction: column;
  }
`

export const TextWrapper = styled.div`
  max-width: 500px;
  padding: 0 0 40px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 25px;

  @media screen and (max-width: 850px) {
    padding: 0 0 20px 0;
  }
`

export const ImgWrap = styled.div`
  max-width: 540px;
  min-width: 340px;
  height: 100%;
`

export const Img = styled.img`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0px;
`

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 42px;
  line-height: 1.1;
  font-weight: 600;
  color: #000;

  @media screen and (max-width: 850px) {
    font-size: 32px;
  }
`

export const Subtitle = styled.p`
  margin-bottom: 15px;
  font-size: 18px;
  line-height: 24px;
  color: #000;
  text-align: justify;

  @media screen and (max-width: 850px) {
    font-size: 16px;
  }
`

export const BulletWrapper = styled.ul`
  margin: 0px;
  padding-left: 20px;
`

export const Bullet = styled.li`
  font-size: 18px;
  line-height: 24px;
  color: #000;
  padding-bottom: 10px;
`